export default __webpack_public_path__ + "static/media/pro.c28a3a2b.svg";